const cartDrawerDgPackageComponentHandles = new Set([
  'homage-package-deal',
  'homage',
  'modus',
  'mythos',
  'optical',
  'silversmith',
  'voyage',
  'the-pistol-pass'
]);

if (!customElements.get('cart-product-recommendations')) {
	customElements.define('cart-product-recommendations', class CartProductRecommendations extends HTMLElement {
		constructor() {
			super();
      this.handleRequests = [];
		}

    abortPendingRequests() {
      if (!this.handleRequests.length) return;

      this.handleRequests.forEach((controller) => controller.abort());
      this.handleRequests = [];
    }

    setLoading(isLoading) {
      this.classList.toggle('loading', isLoading);
      const loading = this.querySelector('.cart__recommendation-loading');
      if (loading) {
        loading.classList.toggle('hidden', !isLoading);
      }
    }

    readCustomerOwnership() {
      this.customerAccessTagHashes = new Set(
        (this.dataset.customerAccessTagHashes || '').split(',').filter(Boolean)
      );
      this.customerOwnsDgPackage = this.dataset.customerOwnsDgPackage === 'true';
      this.customerOwnsHomagePackage = this.dataset.customerOwnsHomagePackage === 'true';
    }

    isOwnedRecommendation(item) {
      const accessTagHash = item.dataset.accessTagHash;
      if (accessTagHash && this.customerAccessTagHashes.has(accessTagHash)) return true;

      const productHandle = item.dataset.productHandle;
      if (this.customerOwnsDgPackage) {
        if (cartDrawerDgPackageComponentHandles.has(productHandle) || item.dataset.includedInDgPackage === 'true') return true;
      }

      return this.customerOwnsHomagePackage && productHandle === 'homage';
    }

		update() {
      this.abortPendingRequests();
      this.readCustomerOwnership();
      this.limit = parseInt(this.dataset.limit, 10) || 5;
      this.setLoading(true);

      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const productIds = [...new Set(cart.items.map((item) => item.product_id).filter(Boolean))].slice(0, 3);

          if (!productIds.length) {
            this.classList.add('hidden');
            this.setLoading(false);
            return;
          }

          this.classList.remove('hidden');
          const limit = Math.max(1, Math.ceil(this.limit / productIds.length) + productIds.length - 1);

          const requests = productIds.map((pId) => {
            const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${pId}&limit=${limit}`;
            const controller = new AbortController();
            this.handleRequests.push(controller);

            return fetch(url, { signal: controller.signal })
              .then((response) => (response.ok ? response.text() : ''))
              .then((text) => {
                if (!text) return [];

                const resultList = getDomHtmlFromText(text, '.item-list');
                if (!resultList) return [];

                return Array.from(resultList.querySelectorAll(this.dataset.itemSelector));
              })
              .catch(() => []);
          });

          Promise.all(requests).then((groups) => {
            const results = [];
            const resultIds = [];

            groups.flat().forEach((item) => {
              const itemId = item.dataset.productId;
              if (!itemId || resultIds.includes(itemId) || this.isOwnedRecommendation(item)) return;

              results.push(item);
              resultIds.push(itemId);
            });

            this.renderResults(results);
            if (!this.querySelector('.cart__recommendation-list .grid__item')) {
              this.classList.add('hidden');
            }
          });
        })
        .catch(() => {
          this.classList.add('hidden');
          this.setLoading(false);
        });
    }

    renderResults(items) {
      if(this.querySelector('.cart__recommendation-loading')) {
        if(this.dataset.removeLoading) {
          this.querySelector('.cart__recommendation-loading').remove();
        } else {
          this.querySelector('.cart__recommendation-loading').classList.add('hidden');
        }
      }
      this.handleRequests = [];
      this.classList.remove('loading');
      this.fisherYates(items);
      const finalItems = items.slice(0, this.limit);
      const list = this.querySelector('.cart__recommendation-list');
      const sliderComponent = document.createElement('slider-component');
      sliderComponent.classList.add('slider-mobile-gutter', 'por');
      this.dataset.componentClasses.split(' ').forEach((htmlClass, indexClass) => {
        sliderComponent.classList.add(htmlClass);
      });
      sliderComponent.dataset.outsidePrevButtonId = `Slider-${this.dataset.sectionId}-prev-button`;
      sliderComponent.dataset.outsideNextButtonId = `Slider-${this.dataset.sectionId}-next-button`;
      const sliderList = document.createElement('ul');
      sliderList.id = `Slider-${this.dataset.sectionId}`;
      sliderList.classList.add('grid');
      this.dataset.gridClasses.split(' ').forEach((htmlClass, indexClass) => {
        sliderList.classList.add(htmlClass);
      });
      finalItems.forEach((item, index) => {
        const sliderItem = document.createElement('li');
        sliderItem.id = `Slide-${this.dataset.sectionId}-${(index + 1)}`;
        sliderItem.classList.add('grid__item', 'slider__slide');
        sliderItem.appendChild(item);
        sliderList.appendChild(sliderItem);
      });
      sliderComponent.appendChild(sliderList);
      list.innerHTML = '';
      list.appendChild(sliderComponent);
      sliderComponent.init();
    }

    fisherYates( array ){
      var count = array.length, randomnumber, temp;
      while( count ){
        randomnumber = Math.random() * count-- | 0;
        temp = array[count];
        array[count] = array[randomnumber];
        array[randomnumber] = temp
      }
    }

    disconnectedCallback() {
      this.abortPendingRequests();
      this.classList.remove('loading');
    }
  });
}
